module.exports = __webpack_public_path__ + "static/banner-equipamentos-6aed6265e703bc509391d01da11a23f3.jpg";